import React from "react";
import PriceBox from "./PriceBox";

function ServicePrice() {
  return (
    <section className="pricing-plan sec-mar">
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-12 col-lg-6 col-xl-5 or1">
            <div className="title black">
              <span>Nos solutions</span>
              <h2>Choisissez le pack adapté à vos objectifs.</h2>
            </div>
          </div>
        </div>

        <div className="row g-4 mt-4">
          <PriceBox
            cartTitle="Pack Site Internet"
            cartSubtitle="Présence en ligne professionnelle"
            features={[
              "Site moderne, responsive et rapide",
              "Structure pensée pour convertir vos visiteurs",
              "Mise en valeur de vos services et de votre expertise",
              "Expérience utilisateur claire et rassurante",
            ]}
          />

          <PriceBox
            cartTitle="Pack Identité Visuelle"
            cartSubtitle="Une image de marque cohérente"
            features={[
              "Création d’un univers graphique professionnel",
              "Identité visuelle adaptée à votre activité",
              "Charte visuelle cohérente sur tous vos supports",
              "Image plus forte, plus crédible et plus mémorable",
            ]}
          />

          <PriceBox
            cartTitle="Pack Site + Identité Visuelle"
            cartSubtitle="La solution complète"
            features={[
              "Création de votre identité visuelle",
              "Conception d’un site internet sur mesure",
              "Harmonie entre branding et présence digitale",
              "Solution idéale pour lancer ou repositionner votre activité",
            ]}
          />
        </div>
      </div>
    </section>
  );
}

export default ServicePrice;